/**
 * Значки. Свой набор, а не библиотека: их здесь два десятка, каждый — четыре
 * строки, и зависимость на сотню килобайт ради этого была бы дорогой.
 *
 * Все нарисованы в одной сетке 24×24 линией 1.7 без заливки — поэтому в ряду
 * они выглядят одним семейством, а не собранием из разных мест.
 */

import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function Icon({ size = 18, children, ...rest }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconPulse = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 12h3.5l2-6 3.5 12 2.5-8 1.8 4H21" />
  </Icon>
);

export const IconSpark = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 3.5 13.7 9 19 10.7 13.7 12.4 12 18 10.3 12.4 5 10.7 10.3 9Z" />
    <path d="M18.5 16.5 19.2 18.8 21.5 19.5 19.2 20.2 18.5 22.5 17.8 20.2 15.5 19.5 17.8 18.8Z" />
  </Icon>
);

export const IconUsers = (p: IconProps) => (
  <Icon {...p}>
    <path d="M15.5 20v-1.6a3.6 3.6 0 0 0-3.6-3.6H6.6A3.6 3.6 0 0 0 3 18.4V20" />
    <circle cx="9.2" cy="7.6" r="3.3" />
    <path d="M21 20v-1.6a3.6 3.6 0 0 0-2.7-3.5M15.8 4.5a3.6 3.6 0 0 1 0 6.9" />
  </Icon>
);

export const IconContent = (p: IconProps) => (
  <Icon {...p}>
    <rect x="3.5" y="3.5" width="17" height="17" rx="3.5" />
    <path d="M7.5 8.5h9M7.5 12h9M7.5 15.5h5" />
  </Icon>
);

export const IconMegaphone = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 10.5v3a1.5 1.5 0 0 0 1.5 1.5H7l7 4.2V6.3L7 10.5H5.5A1.5 1.5 0 0 0 4 12" />
    <path d="M14 6.3 7 10.5v4.5l7 4.2z" />
    <path d="M17.5 9.2a4 4 0 0 1 0 5.6M7 15v3.2a1.6 1.6 0 0 0 3.2 0V16.9" />
  </Icon>
);

export const IconTarget = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <circle cx="12" cy="12" r="4.8" />
    <circle cx="12" cy="12" r="1.3" />
  </Icon>
);

export const IconFlask = (p: IconProps) => (
  <Icon {...p}>
    <path d="M9.5 3.5h5M10.5 3.5v5.2L5.9 17a2.2 2.2 0 0 0 1.9 3.3h8.4a2.2 2.2 0 0 0 1.9-3.3l-4.6-8.3V3.5" />
    <path d="M7.6 14.5h8.8" />
  </Icon>
);

export const IconBroadcast = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="2.4" />
    <path d="M8.3 15.7a5.2 5.2 0 0 1 0-7.4M15.7 8.3a5.2 5.2 0 0 1 0 7.4M5.6 18.4a9 9 0 0 1 0-12.8M18.4 5.6a9 9 0 0 1 0 12.8" />
  </Icon>
);

export const IconSliders = (p: IconProps) => (
  <Icon {...p}>
    <path d="M5 20v-6M5 10V4M12 20v-9M12 7V4M19 20v-4M19 12V4" />
    <path d="M2.8 14h4.4M9.8 11h4.4M16.8 16h4.4" />
  </Icon>
);

export const IconBook = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 5.2A2.2 2.2 0 0 1 6.2 3H19v14.5H6.2A2.2 2.2 0 0 0 4 19.7z" />
    <path d="M4 19.7A2.2 2.2 0 0 1 6.2 17.5H19V21H6.2A2.2 2.2 0 0 1 4 18.8z" />
  </Icon>
);

export const IconLock = (p: IconProps) => (
  <Icon {...p}>
    <rect x="5" y="10.5" width="14" height="10" rx="2.6" />
    <path d="M8.4 10.5V7.8a3.6 3.6 0 0 1 7.2 0v2.7" />
  </Icon>
);

export const IconRefresh = (p: IconProps) => (
  <Icon {...p}>
    <path d="M20 11.5a8 8 0 1 0-1.2 5.3" />
    <path d="M20 4.5v5h-5" />
  </Icon>
);

export const IconMenu = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Icon>
);

export const IconChevronLeft = (p: IconProps) => (
  <Icon {...p}>
    <path d="M14.5 5.5 8 12l6.5 6.5" />
  </Icon>
);

export const IconChevronRight = (p: IconProps) => (
  <Icon {...p}>
    <path d="M9.5 5.5 16 12l-6.5 6.5" />
  </Icon>
);

export const IconLogout = (p: IconProps) => (
  <Icon {...p}>
    <path d="M10 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h4" />
    <path d="M15.5 16 20 12l-4.5-4M20 12H9.5" />
  </Icon>
);

export const IconAlert = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 4.6 21 19.4H3z" />
    <path d="M12 10v4M12 16.8v.2" />
  </Icon>
);

export const IconCheck = (p: IconProps) => (
  <Icon {...p}>
    <path d="M4.5 12.8 9.5 17.8 19.5 6.8" />
  </Icon>
);

export const IconInfo = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 11v5.5M12 7.8v.2" />
  </Icon>
);

export const IconEmpty = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3.5 13.5 6 6.2A2 2 0 0 1 7.9 4.8h8.2A2 2 0 0 1 18 6.2l2.5 7.3" />
    <path d="M3.5 13.5h4.3l1.2 2.4h6l1.2-2.4h4.3v3.7a2 2 0 0 1-2 2H5.5a2 2 0 0 1-2-2z" />
  </Icon>
);

export const IconPlus = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 5v14M5 12h14" />
  </Icon>
);
